var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.creating)?_c('creating',{attrs:{"height":"100%"}}):_vm._e(),_vm._v(" "),(!_vm.creating)?_c('div',{staticClass:"job-board-list"},_vm._l((_vm.jobBoards),function(jobBoard,index){return _c('JobAdvertiseBoardsItem',{key:index,staticClass:"job-board",attrs:{"jobBoard":jobBoard}})}),1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e12ce30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Job/JobAdvertise/JobAdvertiseBoards.vue
// module id = null
// module chunks = 